<app-header></app-header>
<main class="main-content">
  <router-outlet></router-outlet>
</main>
